import { render } from "./ZhaiBACardPC.vue?vue&type=template&id=28be5971&scoped=true"
import script from "./ZhaiBACardPC.vue?vue&type=script&lang=js"
export * from "./ZhaiBACardPC.vue?vue&type=script&lang=js"

import "./ZhaiBACardPC.vue?vue&type=style&index=0&id=28be5971&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28be5971"]])

export default __exports__